.track {
  position: fixed;
  z-index: 50;
  top: 0;
  left: 50%;
  width: min(100%, 430px);
  height: 2px;
  overflow: hidden;
  background: var(--cream);
  pointer-events: none;
  transform: translateX(-50%);
}

.fill {
  width: 100%;
  height: 100%;
  background: var(--pink-deep);
  transform-origin: left center;
  will-change: transform;
}

.track[data-palette='film'] {
  background: var(--pink-deep);
}

.track[data-palette='film'] .fill {
  background: var(--cream);
}
